import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CLIENT_ID_LOADING = 'GET_CLIENT_ID_LOADING';
export const GET_CLIENT_ID_SUCCESS = 'GET_CLIENT_ID_SUCCESS';
export const GET_CLIENT_ID_REJECT = 'GET_CLIENT_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getClientIdLoading = () => ({ type: GET_CLIENT_ID_LOADING });
export const getClientIdSuccess = (payload) => ({ type: GET_CLIENT_ID_SUCCESS, payload });
export const getClientIdReject = (payload) => ({ type: GET_CLIENT_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getClientIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: {
            CustomerId: id
        },
    }, getState);
    return request(`/Clients/web/GetClientsById`, options);
};